<template>
  <div class="tpi">
    <div class="tpi-head">
      <span class="tpi-label">{{ vehicleLabel }}</span>
      <span class="tpi-progress">{{ position }} / {{ lastPosition }}</span>
    </div>

    <div class="tpi-speed">
      <span class="tpi-speed-value">{{ speed }}</span>
      <span class="tpi-speed-unit">km/h</span>
      <span
        v-if="moving"
        class="tpi-state is-moving"
      >{{ $t('Moving') }}</span>
      <span
        v-else
        class="tpi-state"
      >{{ $t('Stopped') }}</span>
    </div>

    <ul class="tpi-list">
      <li>
        <span>{{ $t('Sent date') }}</span><strong>{{ dateLabel }}</strong>
      </li>
      <li v-if="battery">
        <span>{{ $t('Battery level') }}</span><strong>{{ battery }}</strong>
      </li>
      <li v-if="eventName">
        <span>{{ $t('Event') }}</span><strong>{{ eventName }}</strong>
      </li>
      <li>
        <span>{{ $t('Position') }}</span><strong>{{ coordinate }}</strong>
      </li>
      <li v-if="originLabel">
        <span>{{ $t('Origin') }}</span><strong>{{ originLabel }}</strong>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TrackingPointInfo',

  props: {
    point: {
      type: Object,
      default: null,
    },
    index: {
      type: [Number, String],
      default: 0,
    },
    total: {
      type: [Number, String],
      default: 0,
    },
    vehicleDatalhe: {
      type: Object,
      default: null,
    },
  },

  computed: {
    position() {
      return Number(this.index) || 0
    },

    lastPosition() {
      return Math.max(Number(this.total) - 1, 0)
    },

    speed() {
      const valor = Number(this.point && this.point.speed)

      return Number.isFinite(valor) ? valor.toFixed(0) : '0'
    },

    moving() {
      return Number(this.speed) > 0
    },

    battery() {
      if (!this.point) {
        return null
      }

      return this.point.battery_info || this.point.battery || null
    },

    eventName() {
      return (this.point && this.point.event_name) || null
    },

    coordinate() {
      if (!this.point) {
        return '-'
      }

      const lat = Number(this.point.lat)
      const lng = Number(this.point.long !== undefined ? this.point.long : this.point.lon)

      if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
        return '-'
      }

      return `${lat.toFixed(5)}, ${lng.toFixed(5)}`
    },

    dateLabel() {
      const valor = this.point && this.point.position_date

      if (!valor) {
        return '-'
      }

      const data = new Date(String(valor).replace(' ', 'T'))

      return Number.isNaN(data.getTime())
        ? String(valor)
        : data.toLocaleString('pt-BR')
    },

    originLabel() {
      const origem = this.point && this.point.origin

      if (origem === 'movias') {
        return this.$t('Fixed device')
      }

      if (origem === 'app') {
        return this.$t('Mobile device')
      }

      return null
    },

    vehicleLabel() {
      const detalhe = this.vehicleDatalhe || {}
      const veiculo = detalhe.vehicle || detalhe

      if (!veiculo) {
        return this.$t('Route')
      }

      return veiculo.name || veiculo.license_plate || this.$t('Route')
    },
  },
}
</script>

<style scoped>
.tpi {
  min-width: 210px;
  font-size: 0.82rem;
  color: #6e6b7b;
}

.tpi-head {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 0.75rem;
  padding-bottom: 0.4rem;
  border-bottom: 1px solid #ebe9f1;
}

.tpi-label {
  font-weight: 600;
  color: #5e5873;
}

.tpi-progress {
  font-size: 0.72rem;
  color: #b9b9c3;
  font-variant-numeric: tabular-nums;
}

.tpi-speed {
  display: flex;
  align-items: baseline;
  gap: 0.3rem;
  padding: 0.5rem 0 0.4rem;
}

.tpi-speed-value {
  font-size: 1.7rem;
  font-weight: 700;
  line-height: 1;
  color: #5e5873;
  font-variant-numeric: tabular-nums;
}

.tpi-speed-unit {
  font-size: 0.78rem;
  color: #6e6b7b;
}

.tpi-state {
  margin-left: auto;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 2px 7px;
  border-radius: 999px;
  background: #f1f1f4;
  color: #82868b;
  align-self: center;
}

.tpi-state.is-moving {
  background: #e5f8ed;
  color: #28a745;
}

.tpi-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.tpi-list li {
  display: flex;
  justify-content: space-between;
  gap: 0.9rem;
  padding: 0.18rem 0;
}

.tpi-list strong {
  color: #5e5873;
  font-weight: 600;
  text-align: right;
  font-variant-numeric: tabular-nums;
}
</style>
